<template>
  <div
    class="container-fluid"
    v-if="auth == 'loggedin' || token != null || token != undefined"
  >
    <b-card
      header="Megmunkálások"
      border-variant="secondary"
      header-bg-variant="secondary"
      header-text-variant="white"
      class="text-center mt-2"
    >
      <div class="col-sm-6">
        <div class="row">
          <b-button
            size="sm"
            variant="primary"
            @click="$router.push({ name: 'MegmunkalasokNew' })"
            ><b-icon-plus-circle></b-icon-plus-circle>
            Új megmunkálás hozzáadása
          </b-button>
        </div>
      </div>

      <div class="mt-3">
        <table class="table labelsize table-striped text-right">
          <thead>
            <tr>
              <th class="text-left">Látható</th>
              <th class="text-left">Megnevezés</th>
              <th>Ft/fm</th>
              <th>edit</th>
              <th>del</th>
            </tr>
          </thead>
          <tbody is="draggable" group="people" @end="onEnd" :list="list" tag="tbody">
            <tr v-for="(element) in list" :key="element.id">
              <td class="text-left">
                <b-form-checkbox v-model="element.hidden" switch size="sm" @change="radioOn(element)"></b-form-checkbox>
              </td>
              <td class="text-left">{{element.megnevezes}}</td>
              <td>{{element.ar_fm}}</td>
              <td>
                <b-button
                  size="sm"
                  @click="$router.push({ name: 'MegmunkalasokNew', params: { id: element.id } })"
                  variant="outline-success"
                  class="mr-1"
                ><b-icon-pencil></b-icon-pencil>
                </b-button>
              </td>
              <td>
                <b-button
                  size="sm"
                  @click="showMsgBoxTwo(element.id)"
                  variant="outline-danger"
                  class="mr-1"
                ><b-icon-trash></b-icon-trash>
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios'
import router from '../router'
import jwtDecode from 'jwt-decode'
import draggable from 'vuedraggable'

export default {
  components: {
    draggable
  },
  data: () => {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      boxTwo: '',
      token: localStorage.usertoken,
      auth: '',
      userType: decoded.usertype,
      list: []
    }
  },
  methods: {
    radioOn: function (el) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.id = el.id
        if (el.hidden === true) {
          payload.hidden = 1
        } else {
          payload.hidden = 0
        }
        payload.megnevezes = el.megnevezes
        payload.ar_fm = el.ar_fm
        payload.token = this.token
        payload.userType = this.userType
        axios.post('https://' + process.env.ROOT_API + '/megmunkalasok/save', { payload })
          .then(() => { this.loadList() })
          .catch(err => { console.log(err) })
      }
    },
    onEnd: function () {
      for (const el in this.list) {
        this.list[el].order = el
      }
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.list = this.list
        axios.post('https://' + process.env.ROOT_API + '/megmunkalasok/ordersave', { payload })
          .catch(err => { console.log(err) })
      }
    },
    deleteElement: function (req) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.id = req
        axios.post('https://' + process.env.ROOT_API + '/megmunkalasok/delete', { payload })
          .then(() => { this.loadList() })
          .catch(err => { console.log(err) })
      }
    },
    showMsgBoxTwo (reqData) {
      this.$bvModal.msgBoxConfirm('Biztos, hogy törölni akarod?', {
        title: 'Megerősítés',
        size: 'sm',
        okVariant: 'danger',
        okTitle: 'IGEN',
        cancelTitle: 'NEM',
        centered: true
      }).then(value => {
        if (value) this.deleteElement(reqData)
      })
    },
    loadList () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        axios.post('https://' + process.env.ROOT_API + '/megmunkalasok/getlist', { payload })
          .then(res => {
            this.list = res.data
            for (const el in this.list) {
              if (this.list[el].hidden == 0) {
                this.list[el].hidden = false
              } else {
                this.list[el].hidden = true
              }
            }
          })
          .catch(err => { console.log(err) })
      }
    }
  },
  mounted: function () {
    this.loadList()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Megmunkalasok.vue